import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    customers: [],
    customer: {},
    pagination: {},
    new_customer: {},
    validate_form: {
      title: [
        { required: false },
      ],
      name: [
        { required: true, message: 'Customer name is required', trigger: 'blur' },
      ],
      email: [
        { required: true, message: 'Email address is required', trigger: 'blur' },
        { type: 'email', message: 'Please input correct email address', trigger: ['blur', 'change'] },
      ],
      gender: [
        { required: false },
      ],
      newsletter: [
        { type: 'boolean', required: false },
      ],
      verified: [
        { type: 'boolean', required: false },
      ],
      suspended: [
        { type: 'boolean', required: false },
      ],
      // dob: [
      //   { type: 'date', trigger: 'blur' },
      // ],
      phone: [
        { required: false },
      ],
    },
  },
  actions,
  mutations,
  getters,
};
